<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มกลุ่มพนักงานใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ employeeGroupInit.employee_group_code }} -
              {{ employeeGroupInit.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              พนักงานในกลุ่ม
              {{ employeeGroupInit.total_employee }} คน
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: 100%; overflow: auto">
        <tabs class="mt-2" @selectedTab="handleSelectedTab">
          <tab
            title="ข้อมูลทั่วไป"
            class="px-4"
            style="background-color: white"
          >
            <div>
              <label class="body-2">
                รหัสกลุ่มพนักงาน
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                v-model="employeeGroup.employee_group_code"
                :rules="[
                  (v) => !!v || 'โปรดระบุรหัสกลุ่มพนักงาน',
                  (v) =>
                    !v ||
                    (v && v.length <= 10) ||
                    'รหัสกลุ่มพนักงาน ต้องน้อยกว่า 10 ตัวอักษร',
                ]"
                outlined
                dense
                required
                clearable
                @change="checkEmpty($event, 'employee_group_code')"
              >
              </v-text-field>
            </div>
            <div>
              <label class="body-2">
                คำอธิบาย (ไทย)
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                v-model="employeeGroup.title_th"
                :rules="[(v) => !!v || 'โปรดระบุคำอธิบาย']"
                outlined
                dense
                required
                clearable
                @change="checkEmpty($event, 'title_th')"
              >
              </v-text-field>
            </div>
            <div>
              <label class="body-2"> คำอธิบาย (อังกฤษ) </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                v-model="employeeGroup.title_en"
                outlined
                dense
                clearable
                @change="checkEmpty($event, 'title_en')"
              >
              </v-text-field>
            </div>
          </tab>
          <tab
            title="พนักงานในกลุ่ม"
            class="pt-0 px-4"
            style="background-color: white"
          >
            <div v-if="formAction === 'add' && !isShowEmployeeGroupAdd">
              กรุณาเพิ่มข้อมูลทั่วไปก่อน
            </div>
            <div v-else>
              <div
                v-if="
                  uiCtrl && !uiCtrl.isEnable('tab:::employee_group:member:list')
                "
              >
                ไม่มีสิทธิ์เข้าถึงข้อมูล
              </div>
              <div v-else>
                <div>
                  <v-row>
                    <v-col cols="12" lg="6">
                      <label class="caption">ค้นหา</label>
                      <v-text-field
                        v-model="search"
                        class="fix-google-chrome"
                        prepend-inner-icon="mdi-magnify"
                        outlined
                        dense
                        clearable
                        @input="handleSearchEmployee"
                        hide-details
                      >
                      </v-text-field
                    ></v-col>
                    <v-col cols="12" lg="6">
                      <label class="caption">หน่วยงาน</label>
                      <v-autocomplete
                        v-model="organizationFilter"
                        class="fix-google-chrome"
                        :items="organizations"
                        item-text="title_th"
                        item-value="organization_uuid"
                        hide-details
                        outlined
                        dense
                        clearable
                        @change="handleFilterOrganization"
                      >
                      </v-autocomplete
                    ></v-col>
                  </v-row>
                  <v-row class="mb-2">
                    <v-col cols="6">
                      <button
                        :disabled="
                          uiCtrl &&
                          !uiCtrl.isEnable('btn:::employee_group:member:create')
                        "
                        type="button"
                        @click="$emit('onClickAddEmployee')"
                      >
                        <v-icon left small color="primary">mdi-plus</v-icon>
                        <span class="caption primary--text">
                          เพิ่มพนักงานในกลุ่ม
                        </span>
                      </button>
                    </v-col>
                    <v-col class="py-0" cols="6">
                      <v-select
                        style="font-size: 14px"
                        v-model="sort"
                        :disabled="pagination.isLoading"
                        prepend-inner-icon="mdi-sort-ascending"
                        :items="sorts"
                        hide-details
                        @change="handleChangeSort"
                      ></v-select>
                    </v-col>
                  </v-row>
                </div>
                <DynamicScroller
                  :items="employeesGroupMember"
                  :min-item-size="pagination.limit"
                  key-field="employee_uuid"
                >
                  <template v-slot="{ item, index, active }">
                    <DynamicScrollerItem
                      :item="item"
                      :active="active"
                      :data-index="index"
                    >
                      <div class="py-1">
                        <v-card
                          color="#f5f5f5"
                          outlined
                          class="d-flex align-center"
                          v-observe-visibility="
                            item.employee_uuid === lastEmployee.employee_uuid &&
                            !isLastPage
                              ? infiniteScrollHandler
                              : false
                          "
                        >
                          <v-list-item two-line>
                            <v-list-item-content>
                              <v-list-item-title>
                                <span
                                  class="d-inline-block text-truncate"
                                  style="max-width: 360px"
                                >
                                  {{ item.firstname_th }}
                                  {{ item.lastname_th }} [{{
                                    item.employee_code
                                  }}]
                                </span>
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                <span
                                  class="d-inline-block text-truncate"
                                  style="max-width: 360px"
                                >
                                  {{ item.organization.title_th }}
                                </span>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <div class="px-2">
                            <v-btn
                              :disabled="
                                (uiCtrl &&
                                  !uiCtrl.isEnable(
                                    'btn:::employee_group:member:delete'
                                  )) ||
                                item.is_policy_dpc === false
                              "
                              icon
                              @click="handleDeleteEmployeeGroupMember(item)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </v-card>
                      </div>
                    </DynamicScrollerItem>
                  </template>
                </DynamicScroller>
              </div>
            </div>
            <div
              v-if="
                pagination.isLoading &&
                uiCtrl &&
                uiCtrl.isEnable('tab:::employee_group:member:list')
              "
            >
              <div class="py-1">
                <v-card
                  color="#f5f5f5"
                  v-for="num in 2"
                  :key="num"
                  outlined
                  class="mb-2 px-4 py-2"
                >
                  <Skeleton width="200px" />
                  <Skeleton :count="1" />
                </v-card>
              </div>
            </div>
          </tab>
        </tabs>
      </div>
      <v-toolbar flat color="blue-grey lighten-4" v-if="selectedTab === 0">
        <v-row
          justify="center"
          align="center"
          v-if="
            (!isEmployeeGroupDataChange && formAction === 'edit') ||
            (formAction === 'add' && isShowEmployeeGroupAdd)
          "
        >
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::employee_group:delete')
            "
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::employee_group:create')
            "
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::employee_group:update')
            "
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteMember"
      :loading="confirmDialogDeleteLoadingMember"
      :dialogData="confirmDialogDeleteDataMember"
      @cancelConfirmDialog="cancelConfirmDialogDeleteMember"
      @submitConfirmDialog="submitConfirmDialogDeleteMember"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import Tab from '@/components/Tab.vue'
import Tabs from '@/components/Tabs.vue'
import _ from 'lodash'
import { Skeleton } from 'vue-loading-skeleton'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    DynamicScroller,
    DynamicScrollerItem,
    Skeleton,
    Tab,
    Tabs,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    employeeGroup: {
      type: Object,
    },
    employeeGroupInit: {
      type: Object,
    },
  },
  watch: {
    employeeGroup(item) {
      if (item.employee_group_uuid) {
        this.employeesGroupMember = []
        this.pagination.currentPage = 1
        this.getEmployeesGroupMember()
      }
    },
  },
  data() {
    return {
      selectedTab: 0,
      isShowEmployeeGroupAdd: false,
      organizationFilter: '',
      search: '',
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: false,
      },
      employeesGroupMember: [],
      totalEmployeesGroupMember: 0,
      sort: 'firstname_th,asc',
      sorts: [
        { id: 1, text: 'เรียงตามชื่อ (ก - ฮ)', value: 'firstname_th,asc' },
        {
          id: 2,
          text: 'เรียงตามรหัส',
          value: 'employee_code,asc',
        },
        {
          id: 3,
          text: 'เรียงตามหน่วยงาน',
          value: 'organization_th,asc',
        },
      ],
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDeleteMember: false,
      confirmDialogDeleteLoadingMember: false,
      confirmDialogDeleteDataMember: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    lastEmployee() {
      const [lastItem] = this.employeesGroupMember.slice(-1)
      return lastItem || {}
    },
    isLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalEmployeesGroupMember / this.pagination.limit)
      )
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
    isEmployeeGroupDataChange() {
      if (
        this.employeeGroup.employee_group_code !==
          this.employeeGroupInit.employee_group_code ||
        this.employeeGroup.title_th !== this.employeeGroupInit.title_th ||
        this.employeeGroup.title_en !== this.employeeGroupInit.title_en
      ) {
        this.$emit('isEmployeeGroupDataChange', true)
        return true
      }
      this.$emit('isEmployeeGroupDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      fetchEmployeesGroupMember: 'employeesGroup/fetchEmployeesGroupMember',
      deleteEmployeeGroupMember: 'employeesGroup/deleteEmployeeGroupMember',
      addEmployeeGroup: 'employeesGroup/addEmployeeGroup',
      editEmployeeGroup: 'employeesGroup/editEmployeeGroup',
      deleteEmployeeGroup: 'employeesGroup/deleteEmployeeGroup',
    }),
    handleSelectedTab(i) {
      this.selectedTab = i
    },
    handleDeleteEmployeeGroupMember(item) {
      this.confirmDialogDeleteMember = true
      this.confirmDialogDeleteDataMember = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบพนักงาน',
        value: `${item.firstname_th} ${item.lastname_th}`,
        item,
      }
    },
    cancelConfirmDialogDeleteMember() {
      this.confirmDialogDeleteMember = false
    },
    async submitConfirmDialogDeleteMember({ employee_uuid }) {
      try {
        this.search = ''
        this.confirmDialogDeleteLoadingMember = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          employee_group_uuid: this.employeeGroup.employee_group_uuid,
          employee_uuid,
          params: {
            dpc: 'access-employee-group-post-delete-to-list-access-employee-group',
          },
        }

        await this.deleteEmployeeGroupMember(payload)
        this.confirmDialogDeleteLoadingMember = false
        this.confirmDialogDeleteMember = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        this.employeesGroupMember = []
        this.pagination.currentPage = 1
        await this.getEmployeesGroupMember()
        this.$store.commit('employeesGroup/EDIT_EMPLOYEE_GROUP', {
          ...this.employeeGroup,
          employee_group_member: {
            ...this.employeeGroup.employee_group_member,
            total: this.totalEmployeesGroupMember,
          },
        })
      } catch (error) {
        this.confirmDialogDeleteLoadingMember = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleFilterOrganization() {
      this.employeesGroupMember = []
      this.pagination.currentPage = 1
      this.getEmployeesGroupMember()
    },
    handleSearchEmployee: _.debounce(function () {
      // if (this.search === undefined || this.search === null) return
      this.employeesGroupMember = []
      this.pagination.currentPage = 1
      this.getEmployeesGroupMember()
    }, 1000),
    handleChangeSort() {
      this.employeesGroupMember = []
      this.pagination.currentPage = 1
      this.getEmployeesGroupMember()
    },
    async getEmployeesGroupMember() {
      try {
        if (
          this.uiCtrl &&
          !this.uiCtrl.isEnable('tab:::employee_group:member:list')
        ) {
          return
        }

        this.pagination.isLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          employee_group_uuid: this.employeeGroup.employee_group_uuid,
          params: {
            dpc:
              this.uiCtrl &&
              (this.uiCtrl.isEnable('btn:::employee_group:member:delete') ||
                this.uiCtrl.isEnable('btn:::employee_group:member:create'))
                ? 'access-employee-group-post-delete-to-list-access-employee-group'
                : 'access-employee-group-to-list-access-employee-group',
            organization_uuid: this.organizationFilter || undefined,
            is_active: true,
            search: this.search || undefined,
            sort: this.sort,
            limit: `${this.pagination.limit},${
              (this.pagination.currentPage - 1) * this.pagination.limit
            }`,
            is_policy_tag: true,
          },
        }
        const { total: totalEmployeesGroupMember, data: employeesGroupMember } =
          await this.fetchEmployeesGroupMember(payload)
        this.totalEmployeesGroupMember = totalEmployeesGroupMember
        this.setEmployeesGroupMember(employeesGroupMember)
        this.pagination.isLoading = false
      } catch (error) {
        this.pagination.isLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getNextEmployeesGroupMember() {
      try {
        this.pagination.currentPage += 1

        await this.getEmployeesGroupMember()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    setEmployeesGroupMember(employeesGroupMember) {
      this.employeesGroupMember = [
        ...this.employeesGroupMember,
        ...employeesGroupMember,
      ]
    },
    infiniteScrollHandler(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextEmployeesGroupMember()
      }
    },
    checkEmpty(value, field) {
      if (value) {
        this.employeeGroup[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบกลุ่มพนักงาน',
        value: this.employeeGroup.title_th,
        item: this.employeeGroup,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete({ employee_group_uuid }) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        employee_group_uuid,
      }

      this.deleteEmployeeGroup(payload)
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          // this.$refs.form.reset()
          this.$refs.form.resetValidation()
          this.sort = 'firstname_th,asc'
          this.employeesGroupMember = []
          this.isShowEmployeeGroupAdd = false
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            body: {
              employee_group_code: this.employeeGroup.employee_group_code,
              title_th: this.employeeGroup.title_th,
              title_en: this.employeeGroup.title_en || undefined,
            },
          }

          const employeeGroup = await this.addEmployeeGroup(payload)
          this.$emit('addEmployeeGroupSuccess', employeeGroup)
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.isShowEmployeeGroupAdd = true
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            employee_group_uuid: this.employeeGroup.employee_group_uuid,
            body: {
              employee_group_code: this.employeeGroup.employee_group_code,
              title_th: this.employeeGroup.title_th,
              title_en: this.employeeGroup.title_en || undefined,
            },
          }

          await this.editEmployeeGroup(payload)
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          // this.$refs.form.reset()
          this.$refs.form.resetValidation()
          this.sort = 'firstname_th,asc'
          this.employeesGroupMember = []
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    onClose() {
      if (this.isEmployeeGroupDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        // this.$refs.form.reset()
        this.$refs.form.resetValidation()
        this.sort = 'firstname_th,asc'
        this.employeesGroupMember = []
        this.isShowEmployeeGroupAdd = false
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      // this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.sort = 'firstname_th,asc'
      this.employeesGroupMember = []
      this.isShowEmployeeGroupAdd = false
    },
    onReset() {
      this.$emit('formActionCompleted', this.formAction)
      // this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.sort = 'firstname_th,asc'
      this.isShowEmployeeGroupAdd = false
    },
  },
}
</script>
